// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__bko2w","navLink":"Navigation_navLink__rlkxX"};